import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionImportLegacySubscriptions(
    $input: ImportLegacySubscriptionsInput!
  ) {
    actionImportLegacySubscriptions(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      subscriptions {
        id
        legacyId
        name
        renewalAt
        state
        subscriptionPrice
        patient {
          id
          firstName
          lastName
        }
        product {
          id
          name
        }
      }
      subscriptionResults
      warnings
      canFinalize
    }
  }
  ${ErrorMessageInfo}
`;
